import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
import { BookAppointment } from "@grandvisionhq/forms";
import { useFeatureToggles } from "@grandvisionhq/state";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { parseBloomreachInputField } from "../../../../utils/utils/parse-bloomreach-input-field.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
const CmsWidget = ({ content, template, meta }) => {
  const { isGpsStoresEnabled, isStoresPlacePredictionsEnabled } = useFeatureToggles();
  const { title, links, inputField, image, content: text } = content;
  const [link] = useBloomreachLinks(links);
  const input = parseBloomreachInputField(inputField);
  if (!input || !link) {
    return null;
  }
  switch (template) {
    case "book-eye-check":
    // Old template name, can still occur sometimes in BR
    case "book-appointment":
      return /* @__PURE__ */ React.createElement(
        BookAppointment,
        {
          title,
          link,
          inputField: input,
          isLocationEnabled: isGpsStoresEnabled,
          isPlacePredictionsEnabled: isStoresPlacePredictionsEnabled
        }
      );
    case "book-appointment-extended":
      return /* @__PURE__ */ React.createElement(
        BookAppointment,
        {
          title,
          link,
          inputField: input,
          isLocationEnabled: isGpsStoresEnabled,
          isPlacePredictionsEnabled: isStoresPlacePredictionsEnabled,
          text: text?.value,
          imageUrl: image?.url,
          backgroundColor: meta?.backgroundColorHex || meta?.backgroundColor,
          textColor: meta?.textColor
        }
      );
    default:
      return /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1" }, "Widget of type: ", template, " is not defined.");
  }
};
const CmsWidget$1 = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsWidget);
export {
  CmsWidget,
  CmsWidget$1 as default
};
//# sourceMappingURL=Widget.js.map
